<div class="row">
  <div class="col-12">
    <h2><i class="fas fa-cart-plus"></i> Websites</h2>
  </div>
</div>
<ng-container *ngIf="isLoading$ | async; else content"
  ><app-loading-spinner></app-loading-spinner
></ng-container>

<ng-template #content>
  <div class="row" [style.marginTop.px]="10">
    <div class="input-group col-6">
      <div class="input-group-prepend">
        <span class="input-group-text"><i class="fas fa-search"></i></span>
      </div>
      <input
        placeholder="Search by accountId"
        type="text"
        class="form-control form-control-sm filter-input"
        (input)="onSearch($event.target.value)"
      />
    </div>
    <div class="col-6">
      <div [style.textAlign]="'right'">
        <button
          type="button"
          class="btn btn-sm btn-primary"
          (click)="addWebsite()"
        >
          Add website
        </button>
      </div>
    </div>
  </div>

  <div class="row" [style.marginTop.px]="10">
    <div class="col-12">
      <div class="table-responsive">
        <table class="table bg-white table-hover">
          <thead>
            <tr>
              <th scope="col">AccountID</th>
              <th scope="col">WebsiteID</th>
              <th scope="col">SectionID</th>
              <th scope="col">Website name</th>
              <th scope="col">RC4 Secret</th>
              <th scope="col">Script</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let website of websites$ | async">
              <td>{{ website.accountId }}</td>
              <td>
                <div [style.width.px]="150" class="text-truncate">
                  <a
                    (click)="copyToClipboard(website.websiteId, $event)"
                    href="#"
                    class="text-decoration-none"
                    >{{ website.websiteId }}</a
                  >
                </div>
              </td>
              <td>{{ website.sectionId }}</td>
              <td>{{ website.websiteName }}</td>
              <td>
                <div [style.width.px]="150" class="text-truncate">
                  <a
                    (click)="copyToClipboard(website.rc4Secret, $event)"
                    href="#"
                    class="text-decoration-none"
                    >{{ website.rc4Secret }}</a
                  >
                </div>
              </td>
              <td>
                <div [style.width.px]="150" class="text-truncate">
                  <a
                    (click)="copyToClipboard(website.script, $event)"
                    href="#"
                    class="text-decoration-none"
                    >{{ website.script }}</a
                  >
                </div>
              </td>
              <td>
                <div
                  class="btn-group btn-group-sm"
                  role="group"
                  aria-label="actions"
                >
                  <button
                    type="button"
                    class="btn btn-outline-primary btn-sm btn-block"
                    [style.marginTop.px]="0"
                    (click)="editWebsite(website.websiteId)"
                  >
                    <i
                      [style.width.em]="3"
                      [style.paddingRight.px]="0"
                      class="fas fa-edit"
                    ></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-template>
